module.exports = __webpack_public_path__ + "static/media/data-source_merchant-account-provider.1a7e9d63.svg";